<template>
  <div class="add-pay-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="900px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="90px" :label-position="labelPosition">
        <div class="form-flex-box">
          <!--上传图集-->
          <el-form-item label="封面:" prop="cover">
            <!-- <el-upload :action="action" :headers="headers" list-type="picture-card" :on-remove="handleRemove" :on-success="handleAppImageSuccess" :file-list="imgList" name="upload[]">
              <i class="el-icon-plus"></i>
            </el-upload> -->
            <!--上传图集-->
            <imgs-upload
              :cover="params.cover"
              :action="action"
              @successCallback="successCallbackPic"
              :wSize="180"
              :hSize="320"
              :width="'100px'"
              :height="'100px'"
            ></imgs-upload>            
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="标题:" prop="title">
            <el-input v-model.trim="params.title" size="small"></el-input>
          </el-form-item>
          <el-form-item label="楼凤类型:" prop="loufengType">
            <el-select v-model.trim="params.loufengType" size="small" clearable placeholder="请选择楼凤类型">
              <el-option v-for="item in loufengTypeList" :value="item.value" :label="item.label" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数量:" prop="quantity">
            <el-input v-model.trim="params.quantity" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="年龄:" prop="age">
            <el-select v-model.trim="params.age" placeholder="请选择年龄阶段" size="small">
              <el-option v-for="item in ageList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="营业时间:" prop="businessHours">
            <el-input v-model.trim="params.businessHours" size="small"></el-input>
          </el-form-item>
          <el-form-item label="营业月份:" prop="businessDate">
            <el-date-picker v-model="params.businessDate" size="small" type="month" placeholder="选择月" style="width:150px"></el-date-picker>
          </el-form-item>
        </div>

        <div class="form-flex-box">
          <el-form-item label="城市:" prop="city">
            <el-input v-model.trim="params.city" size="small"></el-input>
          </el-form-item>
          <el-form-item label="区/县:" prop="district">
            <el-input v-model.trim="params.district" size="small"></el-input>
          </el-form-item>
          <el-form-item label="是否激活:" prop="isActive">
            <el-switch v-model="params.isActive"></el-switch>
          </el-form-item>
        </div>

        <div class="form-flex-box">
          <el-form-item label="是否验证:" prop="isVerify">
            <el-switch v-model="params.isVerify"></el-switch>
          </el-form-item>
          <el-form-item label="综合评分:" prop="overallRatings">
            <el-input v-model.number="params.overallRatings" size="small"></el-input>
          </el-form-item>
          <el-form-item label="环境评分:" prop="envStar">
            <el-input v-model.number="params.envStar" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="颜值评分:" prop="prettyStar">
            <el-input v-model.number="params.prettyStar" size="small"></el-input>
          </el-form-item>
          <el-form-item label="服务评分:" prop="serviceStar">
            <el-input v-model.number="params.serviceStar" size="small"></el-input>
          </el-form-item>
          <el-form-item label="购买数:" prop="countPurchases">
            <el-input v-model.number="params.countPurchases" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="价格:" prop="price">
            <el-input v-model.trim="params.price" size="small"></el-input>
          </el-form-item>
          <el-form-item label="置顶排序:" prop="topSort">
            <el-input v-model.number="params.topSort" size="small"></el-input>
          </el-form-item>
          <el-form-item></el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="浏览数:" prop="countBrowse">
            <el-input v-model.number="params.countBrowse" size="small"></el-input>
          </el-form-item>
          <el-form-item label="收藏数:" prop="countCollect">
            <el-input v-model.number="params.countCollect" size="small"></el-input>
          </el-form-item>
          <el-form-item label="联系价格:" prop="contactPrice">
            <el-input v-model.number="params.contactPrice" size="small" placeholder="单位：金币"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="服务项目:" prop="serviceItems">
            <el-input type="textarea" v-model.trim="params.serviceItems" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="联系方式:" prop="contact">
            <el-input type="textarea" v-model.trim="params.contact" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="狼友印象:" prop="impression">
            <el-input type="textarea" :rows="5" v-model.trim="params.impression" size="small"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose('form')" size="small">取 消</el-button>
        <el-button type="primary" @click="submit('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '@/api'
import baseConfig from '@/utils/serverUrlConfig'
import { validatorIn } from '@/utils/validator'
import { changeMonth, paramsFilter } from '@/utils/global'
export default {
  props: ['querry'],
  data() {
    return {
      //图集上传
      action: baseConfig.baseServerUrl + '/vid/uploadStaticBatch',
      // imgUrl: baseConfig.imgUrl,
      dialogVisible: false,
      title: '',
      flag: false,
      id: '',
      labelPosition: 'left',
      // imgList: [],
      params: {
        title: '',
        number: '',
        quantity: '',
        age: '',
        cover: [],
        price: '',
        topSort: 0,
        businessHours: '',
        serviceItems: '',
        city: '',
        district: '',
        contact: '',
        contactPrice: '',
        impression: '',
        envStar: '',
        prettyStar: '',
        serviceStar: '',
        overallRatings: '',
        businessDate: '',
        createdAt: '',
        updatedAt: '',
        isActive: true,
        isVerify: true,
        nowMonth: '',
        countPurchases: '',
        countBrowse: '',
        countCollect: '',
      },
      ageList: [
        { label: '20左右', value: '20左右' },
        { label: '25左右', value: '25左右' },
        { label: '30左右', value: '30左右' },
        { label: '35左右', value: '35左右' },
      ],
      loufengTypeList: [{ label: '楼凤兼职', value: 'pluralism' }],
      rules: {
        contactPrice: [{ required: true, message: '必填', trigger: 'blur' }],
        contact: [{ required: true, message: '必填', trigger: 'blur' }],
        number: [{ trigger: 'blur', validator: validatorIn }],
        quantity: [{ trigger: 'blur', validator: validatorIn }],
        envStar: [{ trigger: 'blur', validator: validatorIn }],
        prettyStar: [{ trigger: 'blur', validator: validatorIn }],
        serviceStar: [{ trigger: 'blur', validator: validatorIn }],
      },
    }
  },
  computed: {
    headers() {
      return { Authorization: this.$store.state.token }
    },
  },
  methods: {
    // 提交修改
    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.title === '新增楼凤信息') {
            this.addLouf()
            this.flag = false
          } else {
            this.updateLoufeng()
            this.flag = false
          }
        } else {
          return false
        }
      })
    },
    // 修改
    updateLoufeng() {
      const param = Object.assign({}, this.params, {
        id: this.id,
      })

      if (param.businessDate) {
        param.businessDate = changeMonth(param.businessDate)
      } else {
        param.businessDate = ''
      }
      API.updateLoufeng(paramsFilter(param))
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: '修改成功',
              type: 'success',
            })
            this.$emit('handlerChannelList')
          } else {
            this.$message.error('修改失败')
          }
          this.flag = false
          this.handleClose()
        })
        .catch(() => {
          this.flag = false
          this.handleClose()
        })
    },
    // 添加支付方式
    addLouf() {
      const param = Object.assign({}, this.params, {
        businessDate: changeMonth(this.params.businessDate),
      })
      API.addLoufeng(param)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: '新增成功',
              type: 'success',
            })
            this.$emit('handlerChannelList')
          } else {
            this.$message.error('新增失败')
          }
          this.flag = false
          this.handleClose()
        })
        .catch(() => {
          this.flag = false
          this.handleClose()
        })
    },
    // 关闭弹窗
    handleClose() {
            this.dialogVisible = false
        this.params.cover=[]
      this.$refs['form'].resetFields()
      // this.$parent.getLouFengList()
       this.$emit("handlerChannelList");
    },
    // 封面图上传成功回调
    successCallbackPic(cover) {
           this.params.cover = cover;
    },    
   
    // 打开编辑视频弹窗、传递需要编辑的参k
    open(type, data) {
      this.type = type
      this.dialogVisible = true
      if (this.type === 'edit') {
        this.title = '编辑楼凤信息'
        this.params = { ...{}, ...data }
        this.id = data.id
        // this.params.cover=data.cover
        // if (data.cover && data.cover.length > 0) {
        //   this.imgList = data.cover.map((item) => {
        //     return {
        //       url: this.imgUrl + item,
        //       name: '封面',
        //     }
        //   })
        // }
      } else {
        // this.imgList = []
        const date = new Date()
        this.title = '新增楼凤信息'
        this.params.isActive = true
        this.params.isVerify = true
        this.params.quantity = '1'
        this.params.contactPrice = 90
        this.params.businessHours = '约上即可'
        this.params.serviceItems = '漫游, 胸推, 69式, 口活, 爱爱'
        this.params.envStar = 4
        this.params.prettyStar = 4
        this.params.serviceStar = 4
        this.params.overallRatings = 4
        this.params.businessDate = date
      }
    },
  },
}
</script>

<style lang="scss"  scoped>
.add-pay-box {
  .el-date-picker,
  .el-input {
    width: 150px;
  }
  .form-flex-box {
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>

<style lang="scss">
.add-pay-box .el-upload {
  width: 20%;
}
</style>